module.exports = __webpack_public_path__ + "img/1581530302.e3a8654a.jpg";